module.exports = __webpack_public_path__ + "static/img/2.2706a48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/eng/2.png
// module id = vv+M
// module chunks = 0